import { createContext, useContext } from 'react';

import { SearchCriteriaModel } from 'stores/models/search-criteria-model';

export const SearchCriteriaContext = createContext(new SearchCriteriaModel());

export function useSearchCriteriaContext() {
  return useContext(SearchCriteriaContext);
}
